import { COGNITO_LOGOUT, SET_RUNTIME_VARIABLE } from '../constants';

const DEFAULT_STATE = {
  responsive: 600,
  scrollPrison: false,
  layoutLoading: true,
  layoutLoaded: false,
};

export default function(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case COGNITO_LOGOUT:
      return {
        ...state,
        registrationError: undefined,
        loginError: undefined,
      };
    case SET_RUNTIME_VARIABLE:
      if (state[action.payload.name] === action.payload.value) {
        return state;
      }
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/runtime.js